import Box from "@/components/Box";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_SHOP_TAB_URL } from "@/core/urls";
import { TRADE_DISCOUNTS_QUERY } from "@/graphql/organisations/queries/tradeDiscounts";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import PriceTag from "@/images/PriceTag";
import { useQuery } from "@apollo/client";

import DashboardPanel from "../DashboardPanel";
import { dashboardHeaderIconCircleSize } from "../learningHub/dashboardLayout";
import DashboardCircleArrow from "./DashboardCircleArrow";
import {
  cmpHomeDashboardNarrowColumnWidth,
  cmpHomeDashboardPanelTitleProps,
  cmpHomeDashboardUniformPanelPadding
} from "./dashboardLayout";

export default function ActiveDiscountsPanel() {
  const { organisation } = useOrganisationContext();
  const { resolvedUrls } = useCmpRelatedUrl();
  const discountsUrl = resolvedUrls[CMP_SHOP_TAB_URL].replace(":tab", "discounts");

  const { data, loading } = useQuery(TRADE_DISCOUNTS_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: { organisation: organisation?.id },
    skip: !organisation?.id
  });

  const activeDiscountCount = data?.tradeDiscounts?.length;
  const title =
    !loading && activeDiscountCount != null
      ? `${activeDiscountCount} Active discounts`
      : "Active discounts";

  return (
    <Box width="100%" maxWidth={cmpHomeDashboardNarrowColumnWidth}>
      <DashboardPanel
        title={title}
        titleProps={cmpHomeDashboardPanelTitleProps}
        bg="#17224D"
        titleColor="white"
        padding={cmpHomeDashboardUniformPanelPadding}
        headerStart={<PriceTag size={dashboardHeaderIconCircleSize} withCircle color="#F2F2F2" />}
        headerStartGap={16}
        headerEnd={<DashboardCircleArrow to={discountsUrl} />}
      />
    </Box>
  );
}
